import { createContentfulProps } from "frontend/contentful/lib/create-contentful-props";
import { DirectoryTopperEntry } from "frontend/contentful/schema/toppers";
import { DirectoryTopperProps } from "design-system/sites/alumni/directory-topper/directory-topper";
import {
  DirectorySearchFilterGroup,
  DirectorySearchProps,
} from "design-system/sites/alumni/directory-topper/directory-search";

export interface DirectoryFacet {
  group: string;
  label: string;
  id: string;
  featured: boolean;
  hidden?: boolean;
}

export const facets: Array<DirectoryFacet> = [
  {
    group: "Employment",
    label: "Current Company",
    id: "currentOrganizationName",
    featured: true,
  },
  {
    group: "Employment",
    label: "Company",
    id: "organizationName",
    featured: false,
  },
  {
    group: "Employment",
    label: "Function",
    id: "JobFunction",
    featured: false,
  },
  { group: "Employment", label: "Industry", id: "industry", featured: true },
  {
    group: "Employment",
    label: "Country",
    id: "officeCountrySorted",
    featured: false,
  },
  {
    group: "Employment",
    label: "State",
    id: "officeStateCode",
    featured: false,
  },
  // Added officeCity facet
  {
    group: "Employment",
    label: "City",
    id: "officeCity",
    featured: false,
    hidden: true,
  },
  {
    group: "Employment",
    label: "Position",
    id: "positionLevel",
    featured: false,
  },
  {
    group: "Employment",
    label: "Military Service",
    id: "militaryService",
    featured: false,
  },

  { group: "Personal", label: "Interests", id: "interest", featured: true },
  {
    group: "Personal",
    label: "Home Country",
    id: "homeCountrySorted",
    featured: true,
  },
  { group: "Personal", label: "Gender", id: "genderLabel", featured: false },
  {
    group: "Personal",
    label: "Country of Origin",
    id: "countryOfOriginDesc",
    featured: false,
  },
  {
    group: "Personal",
    label: "Home State",
    id: "homeStateCode",
    featured: false,
  },
  {
    group: "Personal",
    label: "Home City",
    id: "homeCity",
    featured: false,
  },
  {
    group: "Personal",
    label: "Deceased Alumni",
    id: "includeDeceased",
    featured: false,
  },
  {
    group: "Education",
    label: "HBS Degree/Program",
    id: "degreeCode",
    featured: false,
  },
  //  Added classYear facet
  {
    group: "Education",
    label: "Class Year",
    id: "classYear",
    featured: false,
    hidden: true,
  },
  // Added sectionName facet
  {
    group: "Education",
    label: "Section",
    id: "sectionName",
    featured: false,
    hidden: true,
  },
  {
    group: "Education",
    label: "Harvard University",
    id: "nonHBSDegreeCode",
    featured: false,
  },
  {
    group: "Education",
    label: "College",
    id: "nonHBSInstitutionName",
    featured: false,
  },
  { group: "HBS", label: "Clubs Region", id: "club", featured: false },
  {
    group: "HBS",
    label: "Volunteer/Committee",
    id: "HBSVolunteerRoleDisplay",
    featured: false,
  },
];

export const createDirectoryTopperProps = createContentfulProps<
  DirectoryTopperEntry,
  DirectoryTopperProps
>(({ entry }) => {
  const featuredFacets = facets
    .filter((facet) => facet.featured)
    .map((facet) => facet.id);
  const filters: Array<DirectorySearchFilterGroup> = [];

  const searchProps: DirectorySearchProps = {
    searchInputLabel: entry.fields.searchPlaceholder,
    searchQuery: "",
    onSearchQueryChange: () => null,
    filterGroups: filters,
    featuredFilterIds: featuredFacets,
    onSubmitSearch: () => null,
    selectedFacets: {},
  };

  const props: DirectoryTopperProps = {
    title: entry.fields.title,
    theme: entry.fields.theme,
    search: searchProps,
  };

  return props;
});
